import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { AutoComplete, Checkbox, Form, Input, Radio, Card, Divider, Steps, Select, Tag, Image, Row, Col, List, Avatar, DatePicker, Dropdown, Button, Menu, Typography, Space } from 'antd';
import './index.css';
import Navbar from '../../layouts/navbar';
import Footer from '../../layouts/footer';
import Slider from "react-slick";
import { InfoCircleOutlined, CalendarOutlined, CreditCardOutlined, SolutionOutlined, WifiOutlined, CheckCircleOutlined, CheckOutlined, EnvironmentOutlined, MessageOutlined, LikeOutlined, StarOutlined } from '@ant-design/icons';
import { AiOutlineWifi } from "react-icons/ai";
import { FaShower, FaSmokingBan } from "react-icons/fa";
import { RiWindyFill } from "react-icons/ri";
import Lottie from 'lottie-react-web';
import checkmark from '../../checkmark.json';
import failed from '../../failed.json';
import { useNavigate } from 'react-router-dom';
import { mstAuth, mstGeneral } from '../../mobx';
import { useReferral } from '../../utils/referral';

const { Text, Link, Title } = Typography;
const { RangePicker } = DatePicker;
const { Option } = Select;
const { Step } = Steps;
const { TextArea } = Input;

const RegisterScreen = (props) => {
	const {navigateWithReferral} = useReferral();
	const [currentStep, setCurrentStep] = useState(1)
	const [loggingIn, setLoggingIn] = useState(false)
	const [firstName, setFirstName] = useState('')
	const [lastName, setLastName] = useState('')
	const [email, setEmail] = useState('')
	const [password, setPassword] = useState('')
	const [confirmPassword, setConfirmPassword] = useState('')
	const [stateName, setStateName] = useState('')
	const [country, setCountry] = useState('')
	const [countryName, setCountryName] = useState('')
	const [postCode, setPostCode] = useState('')
	const [phone, setPhone] = useState('')
	const [address, setAddress] = useState('')
	const [countries, setCountries] = useState([])
	const [states, setStates] = useState([])

	const onLogin = () => {
		const params = {
			first_name: firstName,
			// last_name: lastName, 
			email: email,
			password: password, 
			// state: stateName, 
			// country: country, 
			// postcode: postCode,
			phone_number: phone,
			// address: address
		};
		console.log("check params ===> ", params)
		setLoggingIn(true)
		mstAuth.register(params)
		.then((response) => {
			setLoggingIn(false)
			// console.log("check response ===> ", response)
			navigateWithReferral('/reservation/otp_verification', { state: { uuid: response.UUID, email: email }} )
		})
		.catch((error) => {
			setLoggingIn(false)
			alert(`[${error.error_code}] ${error.error_message}`)
		})
		// setLoggingIn(true)
		// setTimeout(() => {
		// 	setLoggingIn(false)
		// }, 3000)
	};

	useEffect(() => {
		// get states
		// mstGeneral.fetchStates()
		// .then((response) => {
		// 	let array = []
		// 	response.map((item) => {
		// 		array.push({
		// 			code: item.state_code,
		// 			value: item.state_name
		// 		})
		// 	})
		// 	setStates(array)
		// })
		// .catch((error) => {
		// 	alert(error)
		// })
		// get states
		// mstGeneral.fetchCountries()
		// .then((response) => {
		// 	let array = []
		// 	response.map((item) => {
		// 		array.push({
		// 			code: item.country_code,
		// 			value: item.country_name
		// 		})
		// 	})
		// 	setCountries(array)
		// })
		// .catch((error) => {
		// 	alert(error)
		// })
	},[])

	const onChangeInput = (type, value) => {
		if (type === 'firstName') {
			setFirstName(value)
		} else if (type === 'lastName') {
			setLastName(value)
		} else if (type === 'email') {
			setEmail(value)
		} else if (type === 'password') {
			setPassword(value)
		} else if (type === 'confirmPassword') {
			setConfirmPassword(value)
		} else if (type === 'postCode') {
			setPostCode(value)
		}	else if (type === 'phone') {
			setPhone(value)
		} else if (type === 'address') {
			setAddress(value)
		}
	};

	const onChangeSelect = (type, value) => {
		if (type === 'state') {
			setStateName(value.code)
		} else if (type === 'country') {
			setCountry(value.code)
		}
	};

	const onForgotPassword = () => {
		setCurrentStep(2)
	};

	return (
		<div id="RegisterScreen">
			<div className="container">
				<Navbar />
				{
					currentStep === 1 ?
					(
						<React.Fragment>
							<div className="pageTitleWrapper">
				      	<Text className="pageTitle">Register</Text>
				      </div>
				      <Divider className="pageTitleDivider" />
				      <Form
					      name="basic"
					      labelCol={{ span: 24 }}
					      wrapperCol={{ span: 24 }}
					      initialValues={{ remember: true }}
					      style={{ marginTop: '1em' }}
					      // onFinish={onFinish}
					      // onFinishFailed={onFinishFailed}
					      autoComplete="off"
					    >
                
                <Form.Item
					        label="Full Name"
					        name="first_name"
					        rules={[{ required: true, message: 'Required' }]}
					      >
					        <Input onChange={(event) => { onChangeInput("firstName", event.target.value) }} />
					      </Form.Item>

                {/* <Form.Item
					        label="Last Name"
					        name="last_name"
					        rules={[{ required: true, message: 'Required' }]}
					      >
					        <Input onChange={(event) => { onChangeInput("lastName", event.target.value) }} />
								</Form.Item> */}

                <Form.Item
					        label="Phone No"
					        name="phone"
					        rules={[{ required: true, message: 'Required' }]}
					      >
					        <Input onChange={(event) => { onChangeInput("phone", event.target.value) }} />
					      </Form.Item>

					      <Form.Item
					        label="Email"
					        name="email"
					        rules={[{ required: true, message: 'Required' }]}
					      >
					        <Input onChange={(event) => { onChangeInput("email", event.target.value) }} />
					      </Form.Item>		

								{/* <Form.Item
					        label="Address"
					        name="address"
					        rules={[{ required: true, message: 'Required' }]}
					      >
					        <Input onChange={(event) => { onChangeInput("address", event.target.value) }} />
					      </Form.Item>			

								<Form.Item
					        label="Postcode"
					        name="postcode"
					        rules={[{ required: true, message: 'Required' }]}
					      >
					        <Input onChange={(event) => { onChangeInput("postCode", event.target.value) }} />
					      </Form.Item>					

								<Form.Item
					        label="Country"
					        name="country"
					        rules={[{ required: true, message: 'Required' }]}
					      >
									<AutoComplete
										autoComplete="dontshow"
										placeholder="Select Country"
										options={countries}
										onSelect={(value, option) => { onChangeSelect('country', option) }}
										filterOption={(inputValue, option) =>
											option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
										}
									/>
					      </Form.Item>

								<Form.Item
					        label="State"
					        name="state"
					        rules={[{ required: true, message: 'Required' }]}
					      >
					        <AutoComplete
										autoComplete="dontshow"
										placeholder="Select State"
										options={states}
										onSelect={(value, option) => { onChangeSelect('state', option) }}
										filterOption={(inputValue, option) =>
											option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
										}
									/>
									</Form.Item> */}

					      <Form.Item
					        label="Password"
					        name="password"
					        rules={[{ required: true, message: 'Required' }]}
					      >
					        <Input.Password onChange={(event) => { onChangeInput("password", event.target.value) }} />
					      </Form.Item>

						  <Form.Item
					        label="Confirm Password"
					        name="confirm_password"
					        rules={[{ required: true, message: 'Required' }]}
					      >
					        <Input.Password onChange={(event) => { onChangeInput("confirmPassword", event.target.value) }} />
					      </Form.Item>
					     
					      <Form.Item wrapperCol={{ offset: 0, span: 24 }}>
					        <Button type="primary" loading={loggingIn} htmlType="submit" onClick={() => { onLogin() }}>
					          Submit
					        </Button>
					        <Button type="link" onClick={() => { navigateWithReferral('/reservation/login') }}>
					          Go to Login
					        </Button>
					      </Form.Item>
					    </Form>
						</React.Fragment>
					)
					:
					(
						null
					)
				}
	    </div>
	    <Footer />
		</div>
	)
};

export default RegisterScreen;